// eslint-disable-next-line import/prefer-default-export
export const GRID_TYPES = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'EllipseA',
    'Spotlight',
    '1-1-2-3',
    '1-2-2-2',
] as const;

export const GRID_COLUMN_GAP_DEFAULT = 20;
export const GRID_COLUMN_GAP_DEFAULT_XSMALL = 10;
export const GRID_ROW_GAP_DEFAULT = 24;
